import { Line, mixins } from 'vue-chartjs'

const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  data: () => ({
    options: {
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true,
            callback: (value) => (
              `R$ ${(value / 1).toFixed(2).replace('.', ',').toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`
            )
          },
          gridLines: {
            display: true
          },
        }],
        xAxes: [{
          ticks: {
            beginAtZero: true
          },
          gridLines: {
            display: false
          }
        }]
      },

      tooltips: {
        enabled: true,
        mode: 'point',
        callbacks: {
          label: (tooltipItems) => (
            `R$ ${(tooltipItems.yLabel / 1).toFixed(2).replace('.', ',').toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`
          )
        }
      },
      responsive: true,
      maintainAspectRatio: false,
    }
  }),
  mounted() {
    this.renderChart(this.chartData, this.options)
  }
}



// WEBPACK FOOTER //
// ./src/client/home/LineDash.js